<script setup lang="ts">
  import type { PartnerListSummary } from '@api/models';

  import { Button } from '@ui/components/button';
  import { Tooltip, TooltipContent, TooltipTrigger } from '@ui/components/tooltip';

  import PartnerHealthCheckTooltip from '@/components/partners/PartnerCompletenessCheckTooltip.vue';

  defineProps<{
    partner: PartnerListSummary;
    showPause?: boolean;
    showCompletenessCheck?: boolean;
  }>();
</script>

<template>
  <RouterLink
    class="flex overflow-hidden items-center gap-1.5 [&>i]:text-2xs max-w-fit"
    :to="{
      name: 'customers.customer',
      params: {
        id: partner.id,
      },
    }"
    @click.stop
  >
    <Button
      class="inline-block truncate text-left"
      variant="link"
      size="inline"
      :title="partner.computedName"
    >
      {{ partner.computedName }}
    </Button>

    <Tooltip v-if="showPause && partner.isOutreachPaused">
      <TooltipTrigger as-child>
        <span class="inline-flex text-xs">
          <i class="far fa-pause-circle text-warning-700" />
        </span>
      </TooltipTrigger>

      <TooltipContent> Outreach has been paused for this customer. </TooltipContent>
    </Tooltip>

    <PartnerHealthCheckTooltip v-if="showCompletenessCheck" :partner />
  </RouterLink>
</template>

<style scoped></style>
